import React,{ useRef, useState, useEffect } from 'react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
// import axios from 'axios';
// import S3 from "react-aws-s3"
import S3FileUpload from 'react-s3';
import JSZip from "jszip";
// import JSZipUtils from "jszip-utils" 
// import saveAs from 'save-as'

const Dropzone = (props) => {
    const fileInputRef = useRef();
    const modalImageRef = useRef();
    const modalRef = useRef();
    const progressRef = useRef();
    const uploadRef = useRef();
    const uploadModalRef = useRef();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [validFiles, setValidFiles] = useState([]);
    const [unsupportedFiles, setUnsupportedFiles] = useState([]);
    const [errorMessage, setErrorMessage] = useState();
    const [vc,setVc]=useState(0);
    
    useEffect(() => {
        let filteredArr = selectedFiles.reduce((acc, current) => {
            const x = acc.find(item => item.name === current.name);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
        }, []);
        setValidFiles([...filteredArr]);
        
    }, [selectedFiles]);

    const preventDefault = (e) => {
        e.preventDefault();
        // e.stopPropagation();
    }

    const dragOver = (e) => {
        preventDefault(e);
    }

    const dragEnter = (e) => {
        preventDefault(e);
    }

    const dragLeave = (e) => {
        preventDefault(e);
    }

    const fileDrop = (e) => {
        preventDefault(e);
        const files = e.dataTransfer.files;
        if (files.length) {
            handleFiles(files);
        }
    }

    const filesSelected = () => {
        if (fileInputRef.current.files.length) {
            handleFiles(fileInputRef.current.files);
        }
    }

    const fileInputClicked = () => {
        fileInputRef.current.click();
    }

    const handleFiles = (files) => {
        
        for(let i = 0; i < files.length; i++) {
            if (validateFile(files[i])) {
                setSelectedFiles(prevArray => [...prevArray, files[i]]);
            } else {
                files[i]['invalid'] = true;
                setSelectedFiles(prevArray => [...prevArray, files[i]]);
                setErrorMessage('File type not permitted');
                setUnsupportedFiles(prevArray => [...prevArray, files[i]]);
            }
        }
    }

    const validateFile = (file) => {
        
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/x-icon','application/zip'];
        if (validTypes.indexOf(file.type) === -1) {
            return false;
        }

        return true;
    }

    const fileSize = (size) => {
        if (size === 0) {
          return '0 Bytes';
        }
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(size) / Math.log(k));
        return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
    const fileType = (fileName) => {
        return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
    }

    const removeFile = (name) => {
        const index = validFiles.findIndex(e => e.name === name);
        const index2 = selectedFiles.findIndex(e => e.name === name);
        const index3 = unsupportedFiles.findIndex(e => e.name === name);
        validFiles.splice(index, 1);
        selectedFiles.splice(index2, 1);
        setValidFiles([...validFiles]);
        setSelectedFiles([...selectedFiles]);
        if (index3 !== -1) {
            unsupportedFiles.splice(index3, 1);
            setUnsupportedFiles([...unsupportedFiles]);
        }
    }

    const openImageModal = (file) => {
        const reader = new FileReader();
        modalRef.current.style.display = "block";
        reader.readAsDataURL(file);
        reader.onload = function(e) {
            modalImageRef.current.style.backgroundImage = `url(${e.target.result})`;
        }
    }

    const closeModal = () => {
        modalRef.current.style.display = "none";
        modalImageRef.current.style.backgroundImage = 'none';
    }

    const uploadFiles = async () => {

        // var page=this
         var folderName="folderName1"
        // var zipFilename = "zipFilename.zip";
        
        uploadModalRef.current.style.display = 'block';
        setVc(0);
        uploadRef.current.innerHTML = 'File(s) Uploading...';

        if(validFiles.length>50){
            alert("You can add maximum 50 files")
        }
        else{

            const configS3={
                bucketName:'pcna-images',
                // key:'zipFilename.zip',
                dirName:props.props.img_folder,
                region:'ap-south-1',
                accessKeyId:'AKIAU7MO6YSXATZ3BDEH',
                secretAccessKey:'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'           
            };
    
            var zip = JSZip();
            var count = 0;
    
            if(validFiles[0].type=="application/zip"){
                if(validFiles.length>1)
                {
                    props.UpdateUploaded(false)
                    uploadRef.current.innerHTML = `<span class="error">You can either select a zip file containing multiple images or you can directly select multiple images here.<br/> Please do not select zip files and images together.</span>`;
                    progressRef.current.style.backgroundColor = 'red';
                }
                else{
                    props.changeUploadedFileName(validFiles[0].name)
                    S3FileUpload.uploadFile(validFiles[0], configS3)
                    .then(data =>{
                        uploadRef.current.innerHTML = 'File(s) Uploaded';    
                        uploadModalRef.current.style.display = 'none';
                        const uploadPercentage = Math.floor((1) * 100);
                        progressRef.current.innerHTML = `${uploadPercentage}%`;
                        progressRef.current.style.width = `${uploadPercentage}%`;
                        setVc(uploadPercentage);
                        props.UpdateUploaded(true)                        
                    })
                    .catch(err =>{
                        props.UpdateUploaded(false)
                        uploadRef.current.innerHTML = `<span class="error">Error Uploading File(s)</span>`;
                        progressRef.current.style.backgroundColor = 'red';
                    } )
                }           
            }
            else{      
            validFiles.forEach(function(url){
                var filename = url.name;
                zip.file(filename,url);
                count++;
                const uploadPercentage = Math.floor((count / validFiles.length) * 100);
                progressRef.current.innerHTML = `${uploadPercentage}%`;
                progressRef.current.style.width = `${uploadPercentage}%`;
                setVc(uploadPercentage);
    
                if (count == validFiles.length) {
                    
                    zip.generateAsync({type:'blob'}).then(function(content) {
                        // saveAs(content, "zipFilename.zip");
                        content.name=props.props.uploadedFileName
                        S3FileUpload.uploadFile(content, configS3)
                        .then(data =>{
                            uploadRef.current.innerHTML = 'File(s) Uploaded';    
                            uploadModalRef.current.style.display = 'none';
                            props.UpdateUploaded(true)                        
                        })
                        .catch(err =>{
                            props.UpdateUploaded(false)
                            uploadRef.current.innerHTML = `<span class="error">Error Uploading File(s)</span>`;
                            progressRef.current.style.backgroundColor = 'red';
                        } )
                        console.log("Saved..................")
                     })
                     .catch(ex=>{
                         console.log("Not Saved")
                     });
                   }
              });
            }

         }

        }

    const closeUploadModal = () => {
        uploadModalRef.current.style.display = 'none';
        setVc(0);
    }

    return (
        <> 
            <div className="shadow p-3 img-analysis"  >
               <div className="title" >
               IMAGE UPLOAD
               <br/>
               </div>
                <div className="row p-2" >
                <div className={vc !== 100 ?"drop-container ml-2":"drop-container-d ml-2"} onDragOver={dragOver} onDragEnter={dragEnter}
                    onDragLeave={dragLeave} onDrop={fileDrop} onClick={fileInputClicked} disabled={true}   >
                    <div className={vc !== 100 ?"drop-message" : "drop-message-disabled"}>
                       <img className="mr-2" src="assets/media/logos/attachment.svg" alt="attach" /><b>Drag and Drop</b> or browse files
                    </div>
                    <input ref={fileInputRef} className="file-input" type="file"  multiple onChange={filesSelected}  /> {/*disabled={true} */}
                </div>
                <button className={((unsupportedFiles.length === 0 && validFiles.length>0 && !props.imagesUploaded) &&
                 vc !== 100 )?"file-upload-btn":"file-upload-btn-disabled"} 
                 onClick={() => uploadFiles()} >Upload</button>
                <div className="card-body mt-c">
                <CircularProgressbarWithChildren value={vc} style={{width:"230px"}}>
                <div style={{ fontSize: 20, marginTop: -5 }}>
                    <strong>{vc}% <br/>Uploaded</strong> 
                </div>
                </CircularProgressbarWithChildren>
											
				</div>
            </div>
                
                <div className={vc !== 100 ?"file-display-container" : "file-display-container-disabled"}  > 
                {unsupportedFiles.length ? <p>Please remove all unsupported files.</p> : ''}
                    {
                        validFiles.map((data, i) => 
                            <div className="file-status-bar" key={i}>
                                <div onClick={ () => openImageModal(data)}>
                                    <div className="file-type-logo"></div>
                                    <div className="file-type">{fileType(data.name)}</div>
                                    <span className={`file-name ${data.invalid ? 'file-error' : ''}`}>{data.name}</span>
                                    <span className="file-size">({fileSize(data.size)})</span> {data.invalid && <span className='file-error-message'>({errorMessage})</span>}
                                </div>
                                {

                                }
                                <div className="file-remove" onClick={vc !== 100 ?() => removeFile(data.name):""}    >X</div>
                            </div>
                        )
                    }
                </div>
            </div>
            <div className="modal" ref={modalRef}>
                <div className="overlay"></div>
                <span className="close" onClick={(() => closeModal())}>X</span>
                <div className="modal-image" ref={modalImageRef}></div>
            </div>

            <div className="upload-modal" ref={uploadModalRef}>
                <div className="overlay"></div>
                <div className="close" onClick={(() => closeUploadModal())}>X</div>
                <div className="progress-container">
                    <span ref={uploadRef}></span>
                    <div className="progress">
                        <div className="progress-bar" ref={progressRef}></div>
                    </div>
                </div>
            </div>
           
        </>
    );
}

export default Dropzone;
